<div [style]="'max-width: 90vw; min-width: 25vw; width: ' + overrideWidth + 'vw;'">
    <form [formGroup]="addItemForm">
        
        <!-- Header -->
        <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary" style="margin: -24px;">
            <div class="text-lg font-medium">{{title}}</div>
            <button
                mat-icon-button
                (click)="close()"
                [tabIndex]="-1">
                <mat-icon
                    class="text-current"
                    [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
        </div>
        
        <div class="grid sm:grid-cols-4 gap-6 w-full mt-8 max-h-[calc(100vh-200px)] overflow-y-scroll pr-1">
            
            <div *ngIf="additionalPreHtml" class="sm:col-span-4 mt-4 -mb-8">
                <div [innerHTML]="additionalPreHtml"></div>
            </div>
            
            <div class="sm:col-span-4 grid sm:grid-cols-12 gap-x-6 gap-y-4 w-full mt-4">
                <ng-container *ngFor="let configItem of formConfig; let i = index;">
                    <div [class.invisible]="configItem.hide || isHideConfig(configItem)" [id]="'configItem-' + i" [class]="'w-full fuse-mat-dense col-span-' + (configItem.colSpan ?? 12)">
                        <mat-form-field
                            *ngIf="configItem.type != 'toggle' && configItem.type != 'radio' && configItem.type != 'radioMulti' && configItem.type != 'color' && configItem.type != 'heading' && configItem.type != 'files'"
                            class="w-full fuse-mat-dense"
                            [subscriptSizing]="'dynamic'">
                            <mat-label>{{configItem.name | titlecase}}</mat-label>

                            <mat-icon
                                *ngIf="configItem.icon"
                                class="icon-size-5"
                                [svgIcon]="configItem.icon"
                                matPrefix></mat-icon>

                            <input
                                *ngIf="configItem.type != 'date' && configItem.type != 'textarea' && configItem.type != 'select' && configItem.type != 'autocomplete'"
                                [formControlName]="getFormControlName(configItem)"
                                [readonly]="!!configItem.readonly"
                                [type]="configItem.type == 'datetime' ? 'datetime-local' : (configItem.type == 'number' || configItem.type == 'percentage' || configItem.type == 'currency') ? 'number' : 'text'"
                                matInput>

                            <ng-container *ngIf="configItem.type == 'autocomplete'">
                                <input
                                    [formControlName]="getFormControlName(configItem)"
                                    [readonly]="!!configItem.readonly"
                                    [type]="'text'"
                                    [matAutocomplete]="addItemAutocomplete"
                                    (input)="filterAutocomplete($event, configItem)"
                                    matInput>
                                <mat-autocomplete #addItemAutocomplete="matAutocomplete">
                                    <ng-container *ngFor="let option of configItem.filteredOptions">
                                        <mat-option [value]="option">{{option}}</mat-option>
                                    </ng-container>
                                </mat-autocomplete>
                                <mat-icon matSuffix class="text-[#0000008a] mr-[-0.4rem] cursor-pointer">arrow_drop_down</mat-icon>
                            </ng-container>
                                
                            <textarea
                                *ngIf="configItem.type == 'textarea'"
                                [formControlName]="getFormControlName(configItem)"
                                cdkAutosizeMinRows="3"
                                cdkTextareaAutosize
                                matInput></textarea>
                                
                            <span *ngIf="configItem.type == 'currency'" matPrefix>£</span>
                            <span *ngIf="configItem.type == 'percentage'" matSuffix>%</span>

                            <ng-container *ngIf="configItem.type == 'date'">
                                <input
                                    [formControlName]="getFormControlName(configItem)"
                                    [matDatepicker]="picker2"
                                    matInput>
                                <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                                <mat-datepicker #picker2></mat-datepicker>
                            </ng-container>

                            <mat-select *ngIf="configItem.type == 'select'"
                                [formControlName]="getFormControlName(configItem)">
                                <ng-container *ngFor="let option of configItem.options">
                                    <div *ngIf="option.isHeader" class="p-4 pb-2 text-md"><strong>{{option.name}}</strong></div>
                                    <mat-option *ngIf="!option.isHeader" [class]="selectHasHeaders(configItem) ? 'text-md pl-6' : ''" [value]="option.value">{{option.name}}</mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>

                        <div *ngIf="configItem.type == 'heading'" class="text-2xl mt-2">
                            {{configItem.name | titlecase}}
                        </div>

                        <div *ngIf="configItem.type == 'color'" class="flex flex-col">
                            <mat-label>{{configItem.name | titlecase}}</mat-label>
                            <ngx-colors
                                ngx-colors-trigger
                                style="display: inline-block; margin:5px;"
                                [formControlName]="getFormControlName(configItem)"
                                colorPickerControls="no-alpha">
                            </ngx-colors>
                        </div>

                        <div *ngIf="configItem.type == 'toggle'" class="flex flex-col gap-3">
                            <mat-label>{{configItem.name | titlecase}}</mat-label>

                            <mat-slide-toggle
                                *ngIf="configItem.type == 'toggle'"
                                color="primary"
                                (change)="addItemForm.markAsDirty()"
                                [formControlName]="getFormControlName(configItem)">
                            </mat-slide-toggle>
                        </div>

                        
                        <div *ngIf="configItem.type == 'radio'" [class]="'w-full fuse-mat-dense col-span-' + (configItem.colSpan ?? 12)">

                            <mat-label>{{configItem.name | titlecase}}</mat-label>

                            <mat-tab-group *ngIf="configItem.hasTabs" mat-stretch-tabs="false" mat-align-tabs="start" [selectedIndex]="configItem.selectedTab" (selectedIndexChange)="configItem.selectedTab = $event;">
                                <ng-container *ngFor="let tab of getTabNames(configItem)">
                                    <mat-tab [label]="tab"></mat-tab>
                                </ng-container>
                            </mat-tab-group>

                            <mat-radio-group
                                [formControlName]="getFormControlName(configItem)"
                                class="flex flex-col"
                                [class.gap-y-0]="!anyOptionsHaveInfo(configItem)"
                                [class.gap-y-2]="anyOptionsHaveInfo(configItem)"
                                [class.mt-2]="configItem.name">
                                <ng-container *ngFor="let option of getRadioOptions(configItem)">
                                    <mat-radio-button class="-mt-1" [value]="option.value">
                                        <div>
                                            <div class="font-medium">{{option.name}}</div>
                                            <div *ngIf="option.info" class="-mt-0.5 text-sm whitespace-normal leading-normal text-secondary">{{option.info}}</div>
                                        </div>
                                    </mat-radio-button>
                                </ng-container>
                            </mat-radio-group>
                        </div>

                        <div *ngIf="configItem.type == 'radioMulti'" [class]="'w-full fuse-mat-dense col-span-' + (configItem.colSpan ?? 12)">

                            <div class="sticky top-0 z-999 bg-card pb-4 pt-2 mb-2 border-b -mt-2 flex flex-wrap gap-x-2">
                                <ng-container *ngFor="let item of addItemForm.controls[getFormControlName(configItem)].value; let i = index;">
                                    <mat-chip class="my-1" [removable]="true" (removed)="removeRadioMultiChip(i, getFormControlName(configItem))">
                                    {{ getOptionName(configItem.options, item) }}
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                    </mat-chip>
                                </ng-container>
                            </div>

                            <mat-tab-group *ngIf="configItem.hasTabs" mat-stretch-tabs="false" mat-align-tabs="start" [selectedIndex]="configItem.selectedTab" (selectedIndexChange)="configItem.selectedTab = $event;">
                                <ng-container *ngFor="let tab of getTabNames(configItem)">
                                    <mat-tab [label]="tab"></mat-tab>
                                </ng-container>
                            </mat-tab-group>

                            <mat-label>{{configItem.name | titlecase}}</mat-label>
                            <div
                                class="flex flex-col"
                                [class.gap-y-0]="!anyOptionsHaveInfo(configItem)"
                                [class.gap-y-2]="anyOptionsHaveInfo(configItem)">

                                <ng-container *ngFor="let option of getRadioOptions(configItem)">
                                    <div class="flex gap-2 items-center" (click)="addToRadioMulti(option.value, getFormControlName(configItem))">
                                        <button mat-icon-button class="w-8 h-8 min-h-8" color="primary">
                                            <mat-icon class="icon-size-4" [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                                        </button>
                                        <div>
                                            <div class="font-medium">{{option.name}}</div>
                                            <div *ngIf="option.info" class="-mt-0.5 text-sm whitespace-normal leading-normal text-secondary">{{option.info}}</div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>

                        </div>

                        <div *ngIf="configItem.type == 'files'">
                            <mat-label>{{configItem.name | titlecase}}</mat-label>
                            <div class="w-full flex flex-row flex-0 overflow-x-auto overflow-y-hidden" style="height:130px;">
                                <!-- Upload file -->
                                <div>
                                    <button mat-icon-button (click)="openFileUpload(getFormControlName(configItem))">
                                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:paper-clip'"></mat-icon>
                                    </button>
                                </div>

                                <!-- Files -->
                                <ng-container *ngIf="getFiles(getFormControlName(configItem))?.length > 0">
                                    <div class="file-container p-2 mx-1" *ngFor="let file of getFiles(getFormControlName(configItem))">
                                        <!-- Icons -->
                                        <div class="relative text-center">
                                            <div class="inline-block relative text-center">
                                                <mat-icon
                                                    class="icon-size-14 text-hint opacity-50"
                                                    [svgIcon]="'heroicons_solid:document'"></mat-icon>
                                                <div
                                                    class="absolute left-0 bottom-0 px-1.5 rounded text-sm font-semibold leading-5 text-white"
                                                    [class.bg-red-600]="file.extension == '.pdf'"
                                                    [class.bg-blue-600]="file.extension == '.doc'"
                                                    [class.bg-green-600]="file.extension == '.xls'"
                                                    [class.bg-gray-600]="file.extension == '.txt'"
                                                    [class.bg-amber-600]="file.extension == '.jpg'"
                                                    [class.bg-yellow-500]="file.extension == '.png'">
                                                    {{file.extension.toUpperCase()}}
                                                </div>
                                                <button class="absolute" (click)="deleteFile(file, getFormControlName(configItem))">
                                                    <mat-icon class="icon-size-2 text-red-600">close</mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="file-name text-s text-center mt-1 line-clamp-2">{{file.name}}</div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                        
                    </div>
                </ng-container>
            </div>

            <div *ngIf="additionalHtml" class="sm:col-span-4">
                <div [innerHTML]="additionalHtml"></div>
            </div>
        </div>


        <!-- Divider -->
        <div class="my-6 border-t"></div>

        <!-- Actions -->
        <div class="flex flex-row items-between w-full gap-4">
            <button 
                *ngIf="showDeleteButton"
                (click)="deleteItem()"
                mat-stroked-button
                type="button"
                [color]="'warn'">
                {{overrideDeleteText | titlecase}}
            </button>

            <ng-container *ngIf="data.buttons">
                <div class="mr-auto flex items-center gap-4">
                    <ng-container *ngFor="let button of data.buttons">
                        <button
                            *ngIf="!button.isOnRight"
                            (click)="doButtonCallback(button)"
                            mat-flat-button
                            [color]="button.color ?? 'primary'"
                            [class]="button.class"
                        >{{button.name}}</button>
                    </ng-container>
                </div>
            </ng-container>

            <div class="flex items-center justify-end ml-auto gap-4">
                <button
                    (click)="close()"
                    mat-stroked-button
                    type="button">
                    Cancel
                </button>

                <ng-container *ngFor="let button of data.buttons">
                    <button
                        *ngIf="button.isOnRight"
                        (click)="doButtonCallback(button)"
                        mat-flat-button
                        [color]="button.color ?? 'primary'"
                        [class]="button.class"
                    >{{button.name}}</button>
                </ng-container>

                <button
                    (click)="save()"
                    mat-flat-button
                    type="button"
                    [color]="'primary'"
                    [class]="overrideSaveClass"
                    [disabled]="!addItemForm?.valid">
                    {{overrideSaveText | titlecase}}                
                </button>
            </div>
        </div>
    </form>

</div>
